/*
 * @Author: wuqinfa
 * @Date: 2024-02-18 16:41:28
 * @LastEditors: wuqinfa
 * @Description: 
 */
import { getCurrentUser, getShortUrl, } from '@/services/account';

export default {
  namespace: 'global',
  state: {
    userInfo: {},
    isOpenChangePassword: false,
  },
  effects: {
    *getCurrentUser({ payload }: any, { call, put }: any): any {
      const res = yield call(getCurrentUser, payload);

      yield put({
        type: '_setState',
        payload: {
          userInfo: res.data?.account || {},
        },
      });

      return res;
    },

    *getShortUrl({ payload }: any, { call, put }: any): any {
      const res = yield call(getShortUrl, payload);
      const {
        shortUrl = '',
      } = res.data;

      return shortUrl;
    },
  },
  reducers: {
    _setState(state: any, { payload }: any) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};